module.exports = __webpack_public_path__ + "media/images/placeholder-logo-3f6fde2b75d9391d023868d6ef50329b.png";